function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';
import Icon from "./Icon";

var Status = function Status(_ref) {
  var type = _ref.type,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["type", "className"]);

  var name = 'circle';

  switch (type) {
    case 'info':
      name = 'info-circle';
      break;

    case 'muted':
      name = 'circle-thin';
      break;

    case 'success':
      name = 'check-circle';
      break;

    case 'danger':
      name = 'warning';
      break;

    case 'warning':
      name = 'exclamation-circle';
      break;

    default:
  }

  return (
    /*#__PURE__*/
    React.createElement(Icon, _extends({}, props, {
      name: name,
      fixedWidth: true,
      className: classnames("text-".concat(type || 'muted'), className)
    }))
  );
};

Status.displayName = "Status";
export default Status;